export enum RoleSettingsScreenState {
  RoleSettings = 1,
  PermissionsSettings = 2,
  UsersSettings = 3
}
